export const TRUSTED_CLIENTS_DATA = [
  {
    id: 1,
    logo: "assets/images/clients/1-client.jpg",
    alt: "Cheese And Cheese",
    url: "https://cheesencheese.pk/",
  },
  {
    id: 2,
    logo: "assets/images/clients/2-client.png",
    alt: "Bhatti Ventures LLC",
    url: "https://bhattiventures.com/",
  },
];
